import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import UnifiedComputeResource from '../UnifiedCompute.resource';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'deleteCompute';
const CLEAR_GET_COMPUTE_STATE = `${prefix}/CLEAR_STATE`;
export const clearDeleteComputeState = () => {
    return {
        type: CLEAR_GET_COMPUTE_STATE,
        payload: {},
    };
};
const deleteComputeArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return UnifiedComputeResource.deleteCompute(inputPayload.workspaceId, inputPayload.id);
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const deleteComputeEpicReducer = loadResourcesUtils(deleteComputeArgs);
// Reducer
export const deleteComputeReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_GET_COMPUTE_STATE:
            return defaultReducerState;
        default:
            return deleteComputeEpicReducer.reduxChange(state, action);
    }
    return state;
};
export default deleteComputeReducer;

//# sourceMappingURL=DeleteCompute.ducks.js.map
